// extracted by mini-css-extract-plugin
export default {"zoomModal":"d4-z","image":"e4-z","button":"f4-z","isOverlayShown":"g4-z"};